import { CSSResultGroup, html, LitElement, nothing, PropertyValues } from 'lit'
import { customElement, property, query, state } from 'lit/decorators.js'
import { buttonVariantTypes, CSEButton } from 'elements/button/button.js'
import { style } from './button-group.style.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'


@customElement('cse-button-group')
export class CSEButtonGroup extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, style]

  @property({ type: String })
  variant: buttonVariantTypes[number] = 'default'

  @state()
  displayDivider: boolean = true

  @query('slot[name="left"]')
  private leftSlot!: HTMLSlotElement

  @query('slot[name="right"]')
  private rightSlot!: HTMLSlotElement

  protected override updated(changedProperties: PropertyValues): void {
    super.updated(changedProperties)

    const assignedNodesLeft = this.leftSlot.assignedNodes({ flatten: true })
    const assignedButtonsLeft = assignedNodesLeft.map(this.findButton).filter(this.isButton)

    const assignedNodesRight = this.rightSlot.assignedNodes({ flatten: true })
    const assignedButtonsRight = assignedNodesRight.map(this.findButton).filter(this.isButton)
    
    if (assignedButtonsLeft.length !== 1 || assignedButtonsRight.length !== 1) { 
      throw new Error('Invalid button group: should contain exactly 2 buttons')
    }

    [...assignedButtonsLeft, ...assignedButtonsRight].forEach(button => {
      if (button.disabled) {
        this.displayDivider = false
      }
    })
  }

  private findButton(node: Node): CSEButton | null {
    const selector = 'cse-button'
    return node instanceof HTMLElement ? node.closest(selector) ?? node.querySelector(selector) : null
  }

  private isButton(button: CSEButton | null): button is CSEButton {
    return button !== null
  }

  protected override render(): unknown {
    return html`
      <div class="cse-button-group variant-${this.variant}">
        <slot name="left"></slot>
        ${this.displayDivider ? html`<cse-divider orientation="vertical"></cse-divider>` : nothing}
        <slot name="right"></slot>
      </div>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cse-button-group': CSEButtonGroup
  }
}
